import English from "../i18n/en.json";
import { eyesightList } from "../dropdownList/dropdownData";
import { UserSkill, UserEducation, userWorkExp } from "./SkillEN";

export const EnglishCV = (gender, marriage, bloodType, handedness, eyesight, qualifications, japaneseLevel, englishLevel,
    favoriteSubjects, personality, strongPoints, weakPoints, visaHistories, certificateOfEligibility, avatar, address, fullname, otherName,
    yourself, email, phone, birthDay, age, height, weight, otherLevel, certificateJapaneseLevelList, certificateEnglishLevelList, masterData, userSkillData, userEducationData, userWorkExpData
) => {
    const userSkills = UserSkill(masterData, userSkillData);
    const userEducations = UserEducation(userEducationData);
    const userWorkExps = userWorkExp(userWorkExpData);

    const genderList = [
        { value: "0", label: English["gioitinh.khonghienthi"] },
        { value: "1", label: English["gioitinh.nam"] },
        { value: "2", label: English["gioitinh.nu"] },
        { value: "3", label: English["gioitinh.namnu"] },
    ];

    const bloodTypeList = [
        { value: "1", label: English["createcv.khongbiet"] },
        { value: "2", label: "A" },
        { value: "3", label: "B" },
        { value: "4", label: "AB" },
        { value: "5", label: "O" },
    ];

    const marriageList = [
        { value: "1", label: English["kethon.docthan"] },
        { value: "2", label: English["kethon.dakethon"] },
        { value: "3", label: English["kethon.dalyhon"] },
    ];

    const preferredHandList = [
        { value: "1", label: English["taythuan.trai"] },
        { value: "2", label: English["taythuan.phai"] },
    ];

    const qualificationList = [
        { value: "0", label: English["kinhnghiem.khongyeucau"] },
        { value: "1", label: English["bangcap.laixesosan"] },
        { value: "2", label: English["bangcap.laixesotudong"] },
        { value: "3", label: English["bangcap.xemay"] },
        { value: "4", label: English["bangcap.xaydung"] },
        { value: "5", label: English["bangcap.xenang"] },
        { value: "6", label: English["bangcap.may"] },
        { value: "7", label: English["bangcap.lamvuon"] },
    ];

    const certificateOfEligibilityList = [
        { value: "1", label: English["visa.chuatung"] },
        { value: "2", label: English["visa.datung"] },
    ];

    const favoriteSubjectList = [
        { value: "1", label: English["monhoc.toan"] },
        { value: "2", label: English["monhoc.van"] },
        { value: "3", label: English["monhoc.ly"] },
        { value: "4", label: English["monhoc.hoa"] },
        { value: "5", label: English["monhoc.ngoaingu"] },
        { value: "6", label: English["monhoc.dia"] },
        { value: "7", label: English["monhoc.su"] },
        { value: "8", label: English["monhoc.theduc"] },
    ];

    const strongPointList = [
        { value: "1", label: English["sotruong.chudong"] },
        { value: "2", label: English["sotruong.lacquan"] },
        { value: "3", label: English["sotruong.hoatbat"] },
        { value: "4", label: English["sotruong.haihuoc"] },
        { value: "5", label: English["sotruong.thantrong"] },
    ];

    const weakpointList = [
        { value: "1", label: English["sodoan.biquan"] },
        { value: "2", label: English["sodoan.thieukiennhan"] },
        { value: "3", label: English["sodoan.ngaingung"] },
        { value: "4", label: English["sodoan.haysuynghi"] },
        { value: "5", label: English["sodoan.nhutnhat"] },
        { value: "6", label: English["sodoan.tomo"] },
    ];

    const visaTypeList = [
        { value: "1", label: English["visa.dulich"] },
        { value: "2", label: English["visa.thamthan"] },
        { value: "3", label: English["visa.thuongmai"] },
        { value: "4", label: English["visa.quacanh"] },
        { value: "5", label: English["visa.duhoc"] },
        { value: "6", label: English["visa.laodong"] },
    ];

    const personalityList = [
        { value: "1", label: English["tinhcach.thattha"] },
        { value: "2", label: English["tinhcach.nhiettinh"] },
        { value: "3", label: English["tinhcach.noluc"] },
        { value: "4", label: English["tinhcach.quantam"] },
        { value: "5", label: English["tinhcach.nghiemtuc"] },
        { value: "6", label: English["tinhcach.manhme"] },
        { value: "7", label: English["tinhcach.mongmanh"] },
        { value: "8", label: English["tinhcach.noinhieu"] },
        { value: "9", label: English["tinhcach.hienlanh"] },
        { value: "10", label: "Conservative" },
    ];

    let genderPdf = genderList.filter(g => g.value == gender);
    let marriagePdf = marriageList.filter(m => m.value == marriage);
    let bloodPdf = bloodTypeList.filter(b => b.value == bloodType);
    let handPdf = preferredHandList.filter(p => p.value == handedness);
    let eyesightPdf = eyesightList.filter(e => e.value == eyesight);
    let qualificationPdf = qualificationList.filter(q => q.value == qualifications);
    let japanesePdf = certificateJapaneseLevelList.filter(c => c.value == japaneseLevel);
    let englishPdf = certificateEnglishLevelList.filter(c => c.value == englishLevel);
    let favoriteSubjectPdf = favoriteSubjectList.filter(f => f.value == favoriteSubjects);
    let personalityPdf = personalityList.filter(p => p.value == personality);
    let strongPointPdf = strongPointList.filter(s => s.value == strongPoints);
    let weakPointPdf = weakpointList.filter(w => w.value == weakPoints);
    let visaPdf = [];
    if (visaHistories.length > 0 && certificateOfEligibility.value == 2) {
        visaHistories.map((item, key) => {
            let visaTypePdf = visaTypeList.filter(v => v.value == item.visaId.value);
            visaPdf.push({ visaFromDate: item.visaFromDate, visaExpDate: item.visaExpDate, visaType: visaTypePdf[0].label, country: item.country.label });

        })
    } else {
        visaPdf = certificateOfEligibilityList[0].label;
    }

    let data = {
        avatar: avatar,
        address: address,
        fullName: fullname,
        otherName: otherName,
        yourself: yourself,
        email: email,
        phone: phone,
        gender: genderPdf[0].label,
        marriage: marriagePdf[0].label,
        birthDay: birthDay,
        age: age,
        height: height + " cm",
        weight: weight + " kg",
        bloodType: bloodPdf[0].label,
        handedness: handPdf[0].label,
        eyesight: eyesightPdf[0].label,
        qualifications: qualificationPdf[0].label,
        japaneseLevel: japanesePdf[0].label,
        englishLevel: englishPdf[0].label,
        otherLevel: otherLevel,
        certificateOfEligibility: certificateOfEligibility,
        visaHistories: visaPdf,
        userSkills: userSkills,
        userEducations: userEducations,
        userWorkExps: userWorkExps,
        favoriteSubjects: favoriteSubjectPdf[0].label,
        personality: personalityPdf[0].label,
        strongPoints: strongPointPdf[0].label,
        weakPoints: weakPointPdf[0].label,
    }

    return data;
}